import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DocumentTypeEnum, DocumentTypeEnumDescription } from 'src/app/enums/documents..enum';
import { DocumentService } from 'src/app/services/documents.service';

// Services
import { GroupsService } from '../../../services/groups.service';
import { SnackBarService } from 'src/app/ui-services/snackbar/snackBar.service';
import { localStorageAccessConstant } from 'src/app/constants/LocalStorageAccessConstant';

@Component({
    selector: 'app-groups-edit',
    styleUrls: ['./groups-edit.component.scss'],
    templateUrl: './groups-edit.component.html',
})
export class GroupsEditComponent implements OnInit {
    @Output() cancelClicked = new EventEmitter<any>();
    @Input() groupInfo: any;

    // Public Members
    public pageTitle = 'Edit FBO';

    public currentContact: any;
    public contactsData: any;
    public documents: any;
    public policyAndAgreementGroupExemptions: any;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private groupsService: GroupsService,
        private documentService: DocumentService,
        private snackBarService: SnackBarService
    ) {}

    ngOnInit() {
        const id = this.route.snapshot.paramMap.get('id');
        if (id) {
            this.groupsService.get({ oid: id }).subscribe((data: any) => {
                this.groupInfo = data;
            });
            this.documentService.getRecentsAvailableDocuments(Number(id)).subscribe((data: any) => {
                this.documents = data;
            });
        }
        if (sessionStorage.getItem(localStorageAccessConstant.isNewFbo)) {
            sessionStorage.removeItem(localStorageAccessConstant.isNewFbo);
        }
    }
    // Public Methods
    public async saveEdit() {
        await this.groupsService.update(this.groupInfo).toPromise();
        await this.documentService.updateExemptedDocuments(this.groupInfo.oid, this.documents).toPromise();
        this.snackBarService.showSuccessSnackBar('Successfully updated!');
        this.router.navigate(['/default-layout/groups/']);
    }

    public cancelEdit() {
        this.router.navigate(['/default-layout/groups/']);
    }
    public getDocumentType(documentType: DocumentTypeEnum){
        return DocumentTypeEnumDescription[documentType];
    }
}
